import styled from 'styled-components';
import { Row } from 'react-bootstrap';

export const RateSheetRegionRow = styled(Row)`
  align-items: center;
  margin-bottom: 20px;
`;
